import { FormattedMessage } from 'react-intl'

import BodyText from 'LuxKit/Typography/BodyText'
import FormatCurrency from 'components/Common/FormatCurrency'

interface Props {
  priceDifference: number
}

function FlashCancellationOptionPriceDifference({ priceDifference }: Props) {
  if (priceDifference > 0) {
    return (
      <BodyText variant="medium" colour="light-foreground-alt" weight="bold" wrap="no-wrap">
        <FormattedMessage
          id="mGHDJoYlHarKV4E9f2Ln"
          defaultMessage="+{price}"
          description="Positive price difference with plus sign for refundability option"
          values={{ price: <FormatCurrency value={priceDifference} format="roundedDollar" /> }}
        />
      </BodyText>
    )
  }

  if (priceDifference < 0) {
    return (
      <BodyText variant="medium" colour="light-foreground-alt" weight="bold" wrap="no-wrap">
        <FormatCurrency value={priceDifference} format="roundedDollar" />
      </BodyText>
    )
  }

  return null
}

export default FlashCancellationOptionPriceDifference
